import React from 'react';
import ConventionsPage from './ConventionsPage';

export default function CmcApportIndustriePage() {
  return (
    <ConventionsPage
      contractType="APPORT_INDUSTRIE"
      defaultTitle="Convention Apport en industrie (mission coopérative)"
      headerTitle="Convention Apport en industrie"
      subtitle="Mission coopérative — convention individuelle ou collective (multi-coopérateurs)"
      allowCollective
      showMissionFields
      testIdRoot="apport-industrie"
    />
  );
}
